module.exports = "/images/logo.svg?82e65615aae47c5a9bc05999b7d3a2f7";